import useSWR from 'swr'
import { orderRepository } from '~/src/repositories'
import { IGetOrderParams } from '~/src/components/pages/Order/ContactOrder/ContactOrderList'
import { useRecoilState } from 'recoil'
import { browserBackState, BrowserBackState } from '~/src/recoil'

/**
 * useContactOrderHooks
 * @param queryParams
 */
export const useContactOrderHooks = (queryParams: IGetOrderParams | undefined) => {
  const [browserBackStateAtom, setBrowserBackStateAtom] =
    useRecoilState<BrowserBackState>(browserBackState)
  const {
    data: contactOrderList,
    error: contactOrderListError,
    mutate: contactOrderListMutate,
  } = useSWR(['/request-orders', queryParams], () => orderRepository.requestOrder(queryParams))

  return {
    contactOrderList,
    contactOrderListError,
    contactOrderListMutate,
    browserBackStateAtom,
    setBrowserBackStateAtom,
  }
}
